import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import CardPricePreview from "@project/components/CardPrice/CardPricePreview";
export const CardPriceRowItem = {
    label: "Ligne infos prix",
    key: "items",
    type: ContentsCustomTypes.CARD_PRICE_ROW_ITEM,
    children: [
        {
            label: "Libelle",
            key: "label",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Valeur",
            key: "amount",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Complément",
            key: "complement",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const CardPrice = {
    label: "Carte tarif",
    type: ContentsCustomTypes.CARD_PRICE,
    Preview: CardPricePreview,
    editionModal: true,
    icon: "receipt",
    editionModalPosition: "top",
    children: [
        {
            label: "Couleur",
            key: "barColor",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
        {
            label: "Sur-titre",
            key: "surtitle",
            type: ContentsTypes.INPUT,
            value: "Tarif",
        },
        {
            label: "Prix",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Complément prix",
            key: "titleComplement",
            type: ContentsTypes.INPUT,
            value: "HT / poste / mois",
        },
        {
            label: "Niveau du titre",
            key: "component",
            type: ContentsTypes.SELECT,
            options: [
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
            ],
            value: "h3",
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [CardPriceRowItem],
                    value: ContentsCustomTypes.CARD_PRICE_ROW_ITEM,
                },
            ],
        },
    ],
};
